import * as React from 'react'
import { MessageActionDropdownConnected } from './MessageActionDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_MESSAGE_A_ID } from 'mockState'

export const MessageActionDropdownExamples = () => {
  return (
    <div className="MessageActionDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <MessageActionDropdownConnected messageId={MOCK_MESSAGE_A_ID} />
      </Provider>
    </div>
  )
}
